import styled from 'astroturf/react';
import s from 'src/components/Table/Base';
import { Link } from 'react-router-dom';

const TableCellComponent = styled('div')`
  width: 100%;
  a[class*='Base-styles-Link'] {
    width: 100%;
  }
`;

const Item = styled('div')`
  flex: 1;
  font-size: var(--ph-text-sm);
  padding: 8px 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: var(--black);
  min-height: 20px;
  flex: 1 !important;
  padding: 0 !important;
`;

const EntityName = styled('div')`
  display: inline !important;
  transition: all 0.3s ease-in-out;
  text-decoration: none;
  font-size: 14px;
  color: var(--dark-blue);
  border-bottom: 1.5px solid var(--dark-blue);
  &:hover,
  &:focus {
    color: var(--dark-blue) !important;
    text-decoration: none;
    border-color: var(--cyan-green);
    outline: none;
  }
`;

export default {
  ...s,
  TableCellComponent,
  Item,
  EntityName,
};
